export const API_BASE_URL = process.env.REACT_APP_SERVER || "";

if (!API_BASE_URL) {
  console.error("API_BASE_URL이 비어 있습니다. REACT_APP_SERVER 환경변수를 설정하세요.");
} else {
  console.log("[API_BASE_URL]", API_BASE_URL);
}

export const API_ENDPOINTS = {
  login: "/login",
  refresh: "/public/token-refresh",
  me: "me",
  adminClientList: "/admin/client/list",
  adminClientSosContactList: "/admin/client/{id}/sos/contact/list",
  surveyCsv: "/admin/active-data/survey/csv",
  adminClientSosMessage: (id: number) => `/admin/client/${id}/sos/message`,
  adminClientMessage: "/admin/client/{id}/message",
  adminClientSosMessageList: (id: number) => `/admin/client/${id}/sos/message/list`,
};
